import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateWrittenExecutiveSummary: (
  fetchContext: FetchContext,
  nominationId: number,
  content: string,
  accessToken?: string,
) => Promise<void> = async (fetchContext, nominationId, content, accessToken) =>
    fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/written-executive-summary`, {
      method: 'PUT',
      body: JSON.stringify(content),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update written executive summary'));
